import {createStore} from 'vuex'
import Categories from "@/panel/store/modules/categories/index";
import Questions from "@/panel/store/modules/questions/index"

export default createStore({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        Categories, Questions
    }
})
